import moment, { Moment } from 'moment';
import { OutletId } from '@/shared/models/Outlet';

export default class Presence {
  outletId!: OutletId;
  isPresent = false;
  clockedOn: Moment | null = null;

  toggle(): void {
    this.isPresent = !this.isPresent;
    this.clockedOn = moment();
  }
}